module.exports = __webpack_public_path__ + "img/help18.4967edbe.png";